import type { AxiosResponse } from 'axios';
import type { GetAutoCompleteResponse } from 'api/types/autoCompleteApiTypes';

import { donedealAutoCompleteGateway } from 'api/api-utils/commonApiUtils';

async function getAutoCompleteValues(
  searchText: string,
  section?: string,
): Promise<AxiosResponse<GetAutoCompleteResponse>> {
  const response: AxiosResponse<GetAutoCompleteResponse> =
    await donedealAutoCompleteGateway.get(
      `/v2/autocomplete?text=${searchText}${
        section ? `&section=${section}` : ''
      }`,
    );
  return response;
}

export const autoCompleteApi = { getAutoCompleteValues };
